var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-base-layout',[(!_vm.disableHeader)?_c('HeaderDefault',{attrs:{"showIconMenuExpand":false,"type":_vm.type,"legacyLayout":_vm.legacyLayout}}):_vm._e(),_vm._v(" "),_c('v-main',{class:{ 'mt-md-3 pt-md-16 pt-16': _vm.legacyLayout && !_vm.disableHeader }},[_c('FloatingSupport'),_vm._v(" "),_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }